import {
  Box,
  Container,
  Stack,
  Typography,
  darken,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import Background from '../../../assets/images/background-ad-euro.webp';
import HeaderLogo from '../../../assets/images/slex-logo-euro-2024.webp';
import { StyledButton } from '../../../components/Utils/UIUtils';
import Screen from '../../../assets/images/screen-ad-euro.webp';
import VideoSports from '../../../assets/videos/video-ad-euro.mp4';
import MainHeaderOverlap from '../../../components/Header/MainHeaderOverlap';

export default function Hero() {
  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom',
        backgroundSize: 'cover',
      }}
    >
      <MainHeaderOverlap
        transparent="true"
        darkMode="false"
        customLogo={HeaderLogo}
        customLogoWidth="250px"
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '90vh',
        }}
      >
        <Container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1,
            py: { xs: 3, sm: 4, md: 5 },
            height: '100%',
          }}
          maxWidth="lg"
        >
          <Stack gap={1} component={'header'}>
            <Typography
              variant="h1"
              sx={{
                color: 'text.white',
                fontSize: { xs: '32px', md: '40px' },
                fontWeight: '600',
                zIndex: 90,
              }}
            >
              {t('LANDING_PAGES.EURO_QUALIFIERS.TITLE')}
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: 'primary.neutral200',
                fontSize: { xs: '18px', md: '24px' },
                fontWeight: '400',
              }}
            >
              {t('LANDING_PAGES.EURO_QUALIFIERS.DESCRIPTION')}
            </Typography>
          </Stack>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              flexBasis: { sm: '60%', md: '50%' },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <img
              src={Screen}
              alt="Screen"
              style={{
                zIndex: 3,
                width: '100%',
                objectFit: 'contain',
              }}
              loading="lazy"
            />
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '90%',
                height: '90%',
                zIndex: 1,
                overflow: 'hidden',
              }}
            >
              <video
                src={VideoSports}
                autoPlay
                loop
                muted
                playsInline
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain',
                }}
              />
            </Box>
          </Box>

          <Stack gap={2} justifyContent={'center'} alignItems={'center'}>
            <StyledButton
              href="/free-trial"
              target="_blank"
              rel="noopener noreferrer"
              variant="contained"
              size="large"
              sx={{
                p: '24px 32px',
                height: '48px',
                border: '1px solid',
                borderColor: '#fa4616',
                backgroundColor: '#fa4616',
                borderRadius: theme.shape.secondaryBorderRadius,
                '&:hover': {
                  backgroundColor: darken('#fa4616', 0.1),
                  borderColor: darken('#fa4616', 0.1),
                },
                fontSize: { xs: '16px', md: '18px' },
                fontWeight: '400',
              }}
            >
              {t('LANDING_PAGES.EURO_QUALIFIERS.BUTTON')}
            </StyledButton>
            <Typography
              variant="body1"
              sx={{ fontSize: '14px', color: 'primary.neutral300' }}
            >
              {t('HOME_PAGE.HERO.NO_CREDIT_CARD')}
            </Typography>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
